module.exports = __webpack_public_path__ + "img/498-111-6m5.prt.4ca0add0.jpg";